<div *ngIf="isLoading | async"
  class="loading-overlay fixed inset-0 z-[9999] flex items-center justify-center glass-effect"
  [class.fade-in]="isLoading | async">

  <!-- Spinner Clásico -->
  <div *ngIf="type === 'classic'" class="flex flex-col items-center">
    <div class="spinner-modern"></div>
    <div class="text-center">
      <p class="dark:text-dark-text text-black text-lg font-medium mb-2">{{ message }}</p>
      <p class="dark:text-dark-muted text-black/70 text-sm">{{ subMessage }}</p>
    </div>
  </div>
</div>